import actions from 'actions/jobRequests'
import assetCategoryActions from 'actions/assetCategories'
import assetActions from 'actions/assets'
import locationActions from 'actions/locations'
import jobTemplateActions from 'actions/jobTemplates'
import { createFormViewContainer } from 'factories/FormView'
import { createDocumentsDispatchToProps } from 'helpers/formViews'
import documentActions from 'actions/documents'
import Component from 'components/JobRequests/FormView'

export default createFormViewContainer({
  actions,
  extraDispatchToProps: (dispatch, props) => ({
    newItem: (params) => dispatch(actions.newItem(params)),
    sendCreateNotification: (params) => dispatch(actions.sendCreateNotification(params)),
    createJob: (params) => dispatch(actions.createJob(params)),
    decline: (params) => dispatch(actions.decline(params)),
    getAssetCategories: (params) => dispatch(assetCategoryActions.getOptions(params)),
    getAssets: (params) =>
      dispatch(
        assetActions.getOptions({
          pageIndex: 1,
          pageSize: 100,
          ...params,
        })
      ),
    getLocations: (params) =>
      dispatch(locationActions.getItems({ ...params, locationVendingTypes: ['NonVending'] })),
    getTemplates: (params) => dispatch(jobTemplateActions.getOptions(params)),
    copyAllObjectDocuments: (params) => dispatch(documentActions.copyAllObjectDocuments(params)),
    ...createDocumentsDispatchToProps(dispatch, documentActions),
  }),
})(Component)
